import collectionimg from '../../assets/images/img-1.jpg'
import collectionimgtwo from '../../assets/images/men-clothing.jpg'
import collectionimgthree from '../../assets/images/bathlinen.jpg'
import collectionimgfour from '../../assets/images/Homedecor.jpg'
import collectionimgfive from '../../assets/images/BedLined.jpg'
import collectionimgsix from '../../assets/images/homeaccessries.jpg' 


import { Link } from 'react-router-dom';

function HomeCategory() {
  return (

  <div className="container collection-banners">
    <div className="section-header">
      <h2> Category </h2>
      <p> Shop our new arrivals from established brands </p>
    </div>

    <div className="row">
       <div className="col-12 col-sm-6 mb-4">
        <div className="collection-grid-item">
           <Link to="/productList">
          <img
            src={collectionimg}
            alt="Women Tops"
          />
          </Link>
          <div className="details">
            <h3 className="title"> Floor Covering </h3>
            {/* <p> From world's top designer </p> */}
            {/* <Link to="/productListsecand" className="btn">  Shop Now </Link> */}
            </div>
          </div>
      </div>

      <div className="col-12 col-sm-6 mb-4">
        <div className="collection-grid-item">
          <Link to="/tablewear" className="btn"> 
          <img src={collectionimgtwo} alt="Men Shirts" />
          </Link>
          <div className="details">
            <h3 className="title"> TableWear </h3>
            {/* <p> Up to 70% off on selected item </p> */}
            
          </div>
        </div>
      </div>

      <div className="col-12 col-sm-6 mb-4">
        <div className="collection-grid-item">
           <Link to="/bathline" > 
          <img src={collectionimgthree} />
          </Link>
          <div className="details">
            <h3 className="title"> Bath Linen </h3>
            {/* <p> Find your perfect outfit </p> */}
           
          </div>
        </div>
      </div>

      <div className="col-12 col-sm-6 mb-4">
        <div className="collection-grid-item" style={{ marginTop: "-197px" }}>
            <Link to="/homedecor" className="btn"> 
          <img src={collectionimgfour} alt="Accessories" />
           </Link>
          <div className="details">
            <h3 className="title">Home Decor</h3>
            {/* <p> Add finishing touch to your outfit </p> */}
          
          </div>
        </div>
      </div>
       <div className="col-12 col-sm-6 mb-4">
        <div className="collection-grid-item">
           <Link to="/bathline" className="btn"> 
          <img src={collectionimgfive} alt="Men Shirts" />
           </Link>
          <div className="details">
            <h3 className="title"> Bed Linen </h3>
            {/* <p> Up to 70% off on selected item </p> */}
           
          </div>
        </div>
      </div>

       <div className="col-12 col-sm-6 mb-4">
        <div className="collection-grid-item">
          <Link to="/dustbin" className="btn">
          <img src={collectionimgsix} alt="Men Shirts" />
          </Link>
          <div className="details">
            <h3 className="title"> Home Accessories </h3>
            {/* <p> Up to 70% off on selected item </p> */}
            
          </div>
        </div>
      </div>
    </div>
  </div>

  );
}
export default HomeCategory;